import { gql } from 'apollo-angular';

const GET_ALL_ORGANIZATIONS = gql`
  query organizations {
    organizations {
      id
      memberId
      name
      organizationType
      gln
      address {
        address1
        address2
        addressType
        city
        id
        state
        zip
      }
      analyticsAgreement {
        effectiveDate
        id
        status
        terminationDate
      }
      aptitudeAgreement {
        effectiveDate
        id
        status
        terminationDate
      }
    }
  }
`;

export default GET_ALL_ORGANIZATIONS;
